<ng-template #changeMerchantModal let-modal>
  <div class="modal-content p-3">
    <h5>
      {{
        isDeliveryBusiness || (!isDeliveryBusiness && isDifferentServiceMerchant) ? ("heading-title.change-merchant" | translate) : ("heading-title.change-category" | translate)
      }}?
    </h5>
    <p class="text-muted mb-0">{{ "label-title.change-modal-description" | translate }}</p>
    <div class="d-flex gap-2 justify-content-center my-2">
      <button type="button" class="btn w-sm btn-dark" type="button" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="clearCart()">
        {{ "button-title.yes" | translate | titlecase }}
      </button>
      <button type="button" class="btn w-sm btn-outline-dark" type="button" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="closeModal()">
        {{ "button-title.no" | translate | titlecase }}
      </button>
    </div>
  </div>
</ng-template>
